import dayjs from "dayjs";
import { useEffect } from "react";
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import HeadersComponent from "utilFunctions/shared/AntdSharedComponents/HeadersComponent";
import { Badge, Space, Button, Col, Form, Select } from "antd";
import DrawerAntdComponent from "utilFunctions/shared/AntdSharedComponents/DrawerAntdComponent";
import { StyledRow } from "Pages/MyBatchesAntd/MyBatchesHeaderAntd";
import type { DatePickerProps } from "antd";
import { DatePicker } from "antd";
import "./index.css";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import ChipsTagsAntdComponent from "utilFunctions/shared/AntdSharedComponents/ChipsTagsAntdComponent";
export interface selectInterface {
  label: any;
  key: any;
  value: any;
  region?: any;
  id?: any;
}
const monthFormat = "MMM-YYYY";

export const nullOption = [{ label: "All", key: "all", value: null }];
type ISyllabusComplianceBatchAntdFilter = {
  cardTitle?: any;
  chapterData?: any;
  setBatchesData?: any;
  BatchesData?: any;
  setChapterData?: any;
  handleSearchFaculty?: any;
  handleMonthYearFilter?: any;
  mode?: string;
  onSelectClickHandler?: any;
  region: any[];
  applyFilter: any;
  filterState: any;
  setFilterState: any;
  resetHandler: any;
  testTypeListing: any;
  branchOptions: any;
  setBranchOptions: any;
  chipFields: any;
  setChipFields: any;
};
const SyllabusComplianceBatchAntdFilter = ({
  cardTitle,
  region,
  applyFilter,
  filterState,
  setFilterState,
  resetHandler,
  testTypeListing,
  branchOptions,
  setBranchOptions,
  chipFields,
  setChipFields,
}: ISyllabusComplianceBatchAntdFilter) => {
  const navigate = useNavigate();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { masters } = useMasterContext();
  const { screen }: any = useWindowSize();
  const [stream, setStream] = useState<selectInterface[]>(
    masters?.streams ? nullOption.concat(masters.streams) : []
  );
  const [open, setOpen] = useState<boolean>(false);
  const [isFilterApplied, setIsFilterApplied] = useState<any>(false);
  const preFilterStream =
    masters.streams && masters.streams[0] != undefined
      ? masters.streams[0]
      : null;
  const [branches, setBranches] = useState<selectInterface[]>([]);
  const currentDate = dayjs().format("MMM-YYYY");
  const [dateNString, setdateNString] = useState<any>(currentDate);
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Test",
      nickName: "test",
      data: testTypeListing,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Branch",
      nickName: "branchCode",
      data: branches,
      singleSelect: true,
      filterSelectedData: [],
    },
  ]);
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Stream",
        nickName: "stream",
        data: masters?.streams,
        singleSelect: true,
        filterSelectedData: [filterState.stream] as any,
      },
      {
        name: "Test",
        nickName: "testType",
        data: testTypeListing,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Branch",
        nickName: "branchCode",
        data: branches,
        singleSelect: true,
        filterSelectedData:
          filterState.branchCode && filterState.branchCode[0]
            ? [filterState.branchCode[0]]
            : [],
      },
    ]);
  }, [masters?.streams, masters?.branches, testTypeListing]);
  useEffect(() => {
    setStream(userInfo?.userStreams as any);
  }, [userInfo, masters?.streams]);
  useEffect(() => {
    setBranches(masters?.userAssignedBranches);
  }, [masters?.userAssignedBranches]);

  const handleAddFilterArrayList = (name: string, val: any) => {
    if (name === "region") {
      setFilterState((prevState: any) => ({
        ...prevState,
        branchCode: null,
        [name]: val,
      }));
    } else {
      setFilterState((prevState: any) => ({
        ...prevState,
        [name]: val,
      }));
    }
    setChipFields((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };
  const handleClearAllFilter = () => {
    const clearedFilter = {
      ...filterState,
      testType: null,
    };
    setFilterState(clearedFilter);
    setdateNString(currentDate);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return {
          ...ele,
          filterSelectedData:
            ele.name == "Stream"
              ? ([filterState.stream] as any)
              : ele.name == "Branch"
              ? filterState.branchCode && filterState.branchCode[0]
                ? [filterState.branchCode[0]]
                : []
              : [],
        };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    resetHandler && resetHandler();
    setIsFilterApplied(false);
  };
  const handleOptionForBranches = (regionIds: any) => {
    if (regionIds && masters && Array.isArray(masters?.userAssignedBranches)) {
      console.log(
        regionIds,
        masters?.userAssignedBranches,
        "userAssignedBranches"
      );
      const filteredbranches: any = [];
      masters?.userAssignedBranches.forEach((item: any) => {
        if (item.region === regionIds) {
          filteredbranches.push(item);
        }
      });
      setBranchOptions(filteredbranches);
    }
  };

  const HandleApplyFilter = (filterState: any) => {
    applyFilter(filterState);
    console.log(chipFields, "chipFields");
    setFilterState((prevState: any) => ({
      ...prevState,
      chipField: {
        ...prevState.chipField,
        ...chipFields,
      },
    }));
    setIsFilterApplied(true);
    setOpen(!open);
  };
  const filterStateCopy = { ...filterState };
  console.log(preFilterStream, "preFilterStream", filterStateCopy);
  delete filterStateCopy["chipField"];
  const onCloseHandler = (item: any) => {
    console.log(item, "onclosehndlr");
  };
  const filterLength = Object.values(filterStateCopy).filter(
    (ele: any) => ele != null
  ).length;
  const backButtonHandler = () => {
    navigate("/admin/dashboard", {
      replace: true,
      state: {
        selectedStudent: null,
      },
    });
  };
  const onChange: DatePickerProps["onChange"] = (date, dateString) => {
    setdateNString(dateString);
    setChipFields((prevState: any) => ({
      ...prevState,
      month: dateString,
    }));
    handleAddFilterArrayList("month", dateString);
  };

  const Reset = () => (
    <Button
      onClick={() => {
        if (filterLength != 0) {
          handleClearAllFilter();
        }
      }}
    >
      Reset
    </Button>
  );
  const getFieldByVal = (arr: any[], val: any) => {
    const findVal = arr.find((ele: any) => ele.value == val);
    return findVal;
  };
  return (
    <div>
      <DrawerAntdComponent
        title={"Filters"}
        open={open}
        setOpen={setOpen}
        width={450}
        footer={
          <>
            <Space className="d-flex justify-content-end">
              <Button
                type="primary"
                onClick={() => {
                  HandleApplyFilter(filterState);
                }}
                className={"m-0"}
              >
                Apply
              </Button>
              {isFilterApplied && <Reset />}
              <Button onClick={() => setOpen(false)}>Close</Button>
            </Space>
          </>
        }
      >
        <StyledRow gutter={[10, 16]} screen={screen}>
          <Form layout={"vertical"} className="w-100">
            <Col
              xxl={24}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={"filter-input-container-col"}
            >
              <Form.Item label="Stream">
                <Select
                  showSearch
                  value={filterState.stream}
                  style={{ width: "100%" }}
                  size="large"
                  options={stream}
                  onChange={(selected: any) => {
                    handleAddFilterArrayList(
                      "stream",
                      getFieldByVal(stream, selected)
                    );
                  }}
                />
              </Form.Item>
            </Col>
            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
              <Form.Item label="Syllabus Compliance Target Month">
                <DatePicker
                  onChange={onChange}
                  picker="month"
                  format={monthFormat}
                  size="large"
                  value={dayjs(dateNString, monthFormat)}
                  style={{ width: "100%" }}
                  minDate={dayjs("2024-04-01", "YYYY-MM-DD")}
                />
              </Form.Item>
            </Col>

            <Col
              xxl={24}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={"filter-input-container-col"}
            >
              <Form.Item label="Region">
                <Select
                  showSearch
                  value={filterState.region}
                  style={{ width: "100%" }}
                  size="large"
                  options={region}
                  onChange={(selected: any) => {
                    const field = getFieldByVal(region, selected);
                    handleAddFilterArrayList("region", field);
                    console.log(field, "field337");
                    const regionIds = field.id;
                    setBranchOptions([]);
                    handleOptionForBranches(regionIds);
                  }}
                  placeholder="Select region"
                />
              </Form.Item>
            </Col>

            <Col
              xxl={24}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={"filter-input-container-col"}
            >
              <Form.Item label="Branch">
                <Select
                  showSearch
                  value={filterState.branchCode ? filterState.branchCode : null}
                  style={{ width: "100%" }}
                  size="large"
                  options={branchOptions}
                  onChange={(selected: any) => {
                    const field = getFieldByVal(branchOptions, selected);
                    handleAddFilterArrayList("branchCode", field);
                  }}
                  placeholder="Select region"
                />
              </Form.Item>
            </Col>
            <Col
              xxl={24}
              xl={24}
              lg={24}
              md={24}
              sm={24}
              xs={24}
              className={"filter-input-container-col"}
            >
              <Form.Item label="Test">
                <Select
                  showSearch
                  value={filterState.testType ? filterState.testType : null}
                  style={{ width: "100%" }}
                  size="large"
                  options={testTypeListing}
                  onChange={(selected: any) => {
                    handleAddFilterArrayList(
                      "testType",
                      getFieldByVal(testTypeListing, selected)
                    );
                  }}
                  placeholder="Select test"
                />
              </Form.Item>
            </Col>
          </Form>
        </StyledRow>
      </DrawerAntdComponent>
      <HeadersComponent
        cardTitle={cardTitle}
        backButtonHandler={backButtonHandler}
      >
        <Space>
          {filterLength > 0 && ["xxl", "xl", "lg"].includes(screen) && (
            <ChipsTagsAntdComponent
              filterState={removeEmptyFields(filterStateCopy)}
              chipsFields={filterState?.chipField}
              onCloseHandler={onCloseHandler}
              isShowCross={false}
            ></ChipsTagsAntdComponent>
          )}
          <Badge count={filterLength && filterLength > 0 ? filterLength : 0}>
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              Filters
            </Button>
          </Badge>
          {isFilterApplied && <Reset />}
        </Space>
      </HeadersComponent>
    </div>
  );
};
export default SyllabusComplianceBatchAntdFilter;
